window.observeForm = function (form, validate_params, before_observer) {
    validate_params.submitHandler = function (form) {
        if (before_observer) {
            before_observer(form);
        }
    };
    // 將 form 跟 plugin 綁定
    $(form).validate(validate_params);
};

// ----------------------------------------------------------------
//                設定預設的功能
// ----------------------------------------------------------------
$.validator.setDefaults({
    showErrors: function (map, errorList) {
        // there's probably a way to simplify this
        let focussed = document.activeElement;

        if (focussed) {
            let _rd_required = $(focussed).closest(".rd_show_validator_error");

            // 因為這裡取不到select的focus 所以只能把select的事件寫在下面
            if (
                $(focussed).is("input, textarea") &&
                _rd_required.find(".rd_notice").length > 0
            ) {
                _rd_required.find(".rd_notice").remove();
                $(focussed).css("border", "1px solid #ddd");
            }
        }

        $.each(errorList, function (index, error) {
            let element = error.element;
            let target = $(element).closest(".rd_show_validator_error");

            if ($(element).is("input,textarea")) {
                if ($(target).find(".rd_notice").length > 0) {
                    $(target).find(".rd_notice").remove();
                    $(element).css("border", "1px solid #ddd");
                }
                $(element).css("border", "1px solid #dc3545");
            } else if ($(element).is("select")) {
                if ($(target).find(".rd_notice").length > 0) {
                    $(target).find(".rd_notice").remove();
                    $(element)
                        .closest(".rd_required")
                        .find(".selectric")
                        .css("border", "1px solid #ddd");
                }
                $(element)
                    .closest(".rd_required")
                    .find(".selectric")
                    .css("border", "1px solid #dc3545");
                // 要綁定移除錯誤的事件
                $(element).on("change", function () {
                    if ($(this).val() !== "") {
                        $(this)
                            .closest(".rd_required")
                            .find(".rd_notice")
                            .remove();
                        $(this)
                            .closest(".rd_required")
                            .find(".selectric")
                            .css("border", "1px solid #ddd");
                    }
                });
            }
            $(target).append(
                '<div class="rd_notice" style="width: 100%;margin-top: .25rem;font-size: 80%;color: #dc3545;">' +
                    error.message +
                    "</div>"
            );
        });
    },
    invalidHandler: function (event, validator) {
        //若無錯誤則跳過以下步驟
        if (!validator.numberOfInvalids()) return;

        // 以Class「rd_required」為基準，作為捲軸移動參考
        let obj = $(validator.errorList[0].element);
        let top = 0;
        top = obj.closest(".rd_required").offset().top;
        if ($("#rd_header").length) {
            top -= $("#rd_header").height() * 2;
        }

        $("html,body").animate(
            {
                scrollTop: top,
            },
            500
        );
    },
});
